import { render, staticRenderFns } from "./BirthdateChangeModal.vue?vue&type=template&id=c16c793e&scoped=true&"
import script from "./BirthdateChangeModal.vue?vue&type=script&lang=js&"
export * from "./BirthdateChangeModal.vue?vue&type=script&lang=js&"
import style0 from "./BirthdateChangeModal.vue?vue&type=style&index=0&id=c16c793e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c16c793e",
  null
  
)

export default component.exports